import pako from 'pako';
import { Buffer } from 'buffer';

export const executorDecompress = (executorResponse) => {
  try {
    // decode base 64
    let bin = Buffer.from(executorResponse?.levelOutputs ?? '', 'base64');
    // decompress zlib
    let json = pako.inflate(bin, { to: 'string' });
    // parse json
    let levelOutputs = JSON.parse(json);

    let levelResults = executorResponse?.levelResults ?? Array(levelOutputs.length).fill({});

    let compileError = executorResponse?.compileErrors?.[0];
    if (compileError && levelOutputs?.[0]?.log) {
      levelOutputs[0].log.push({ tag: null, index: 0, pipe: 'err', message: compileError });
    }

    return levelResults.map((value, index) => ({
      ...value,
      steps: levelOutputs?.[index],
      index: executorResponse.levelToRun || index,
    }));
  } catch (e) {
    console.log('Could not decompress executor response. Error:', e);
  }
};
